import React from 'react';
import { useAuth } from '../context/AuthContext';
import ChildDashboard from './ChildDashboard';
import ParentDashboard from './ParentDashboard';
import TeacherDashboard from './TeacherDashboard';
import ExtendedDashboard from './ExtendedDashboard';

export default function DashboardRouter() {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === 'child') return <ChildDashboard />;
  if (user.role === 'parent') return <ParentDashboard />;
  if (user.role === 'teacher') return <TeacherDashboard />;
  if (user.role === 'extended') return <ExtendedDashboard />;
  return null;
}
